import { Col, Container, Row } from '@bootstrap-styled/v4';
import React from 'react';
import colors from 'shared-components/theme/colors';
import { baseURL } from 'shared-components/theme/helpers';
import styled from 'styled-components';
import SectionTitle from './section-tag';
import IntroductionTitle from './introduction-title';
import IntroductionDesc from './introduction-desc';
import Media from 'shared-components/theme/medias';
import Cost from './cost';
import ScrollAnimation from 'react-animate-on-scroll';
const Talent = () => {
    return (
        <Wrap id="talent">
            <Container>
                <Row>
                    <Col lg="6">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOnce={true}>
                            <ImageContainer>
                                <img
                                    src={`${baseURL}assets/images/geos/pakistan/t_img.png`}
                                    style={{ width: '100%' }}
                                    className="sec_img"
                                    loading="lazy"
                                />
                            </ImageContainer>
                        </ScrollAnimation>
                    </Col>
                    <Col lg="6" className="text_col">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOnce={true}
                            delay={100}>
                            <SectionTitle tag={'THE TALENT'} />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOnce={true}
                            delay={150}>
                            <IntroductionTitle
                                title={'Young. Driven. Ready.'}
                                textColor={'#04190D'}
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOnce={true}
                            delay={200}>
                            <IntroductionDesc
                                desc={
                                    'Customer experience is a respected career in Pakistan, where over 300,000 BPO digitally native, performance-driven professionals are proudly powering global CX. With the BPO industry projected to generate over <b>$900 million in the region this year</b>, the country is rapidly becoming a key force in the future of customer experience.'
                                }
                                textColor={'#04190D'}
                            />
                        </ScrollAnimation>
                    </Col>
                </Row>
                <Cost />
            </Container>
        </Wrap>
    );
};

export default Talent;

const Wrap = styled.section`
    background: ${colors.geoWhite[100]};
    padding-top: 40px;
    position: relative;
    z-index: 2;
    scroll-margin-top: 100px;
    .text_col {
        padding: 0 80px;

        ${Media('laptops')} {
            padding: 0 30px;
        }
    }
`;

const ImageContainer = styled.div`
    overflow: hidden;
    margin-top: -160px;
    border-radius: 10px;
    img {
        transition: 0.3s ease;
    }

    &:hover {
        img {
            transform: scale(1.05);
        }
    }

    ${Media('large')} {
        margin-top: -10.277vw;
    }
    ${Media('laptops')} {
        margin-top: 0;
    }
`;
